import React from "react";
import { RBPaySettingsContentPage } from "./pages/RBPaySettingsContentPage";

export const RBPaySettingsPage: React.FC = () => <RBPaySettingsContentPage />;
